import { type ApiHandlerContract, ApiService } from '../../../types/api';
import type { CustomerGroupBuilderValidated } from '../types/customer-group.schema';
import { CustomerGroupSettingsApi, type CustomerGroupSettingsApiContract } from './settings.api';

export interface CustomerGroupApiContract {
  create(group: CustomerGroupBuilderValidated): Promise<void>;
  update(group: CustomerGroupBuilderValidated): Promise<void>;
  delete(): Promise<void>;
  settings(): CustomerGroupSettingsApiContract;
}

export class CustomerGroupApi extends ApiService implements CustomerGroupApiContract {
  constructor(
    api: ApiHandlerContract,
    private slug: string,
  ) {
    super(api);
  }

  public create(group: CustomerGroupBuilderValidated): Promise<void> {
    return this.api.proxy({
      method: 'POST',
      path: '/v1/customer-groups',
      payload: {
        slug: this.slug,
        name: group.name,
        parent_slug: group.parent_slug,
      },
    });
  }

  public update(group: CustomerGroupBuilderValidated): Promise<void> {
    return this.api.proxy({
      method: 'PATCH',
      path: '/v1/customer-groups/{slug}',
      params: { slug: this.slug },
      payload: {
        name: group.name,
        parent_slug: group.parent_slug,
      },
    });
  }

  public delete(): Promise<void> {
    return this.api.proxy({
      method: 'DELETE',
      path: '/v1/customer-groups/{slug}',
      params: { slug: this.slug },
    });
  }

  public settings(): CustomerGroupSettingsApiContract {
    return new CustomerGroupSettingsApi(this.api, this.slug);
  }
}
